//import Link from "next/link";
import sendGAEvent from "@/utils/gaEvent";
import SVG from "react-inlinesvg";

const index = ({ breadcrumbList = [], isRajasthan = false, isMadhya = false, isHR = false, isUP = false, isBH = false, isCGH = false, isUK = false, isBiz = false, isPB = false }) => {
  return (
    <div className="bg-gray-100 py-2 overflow-auto [&::-webkit-scrollbar]:hidden   ">
      <nav className="text-gray-700 text-sm md:mx-4" aria-label="Breadcrumb">
        <ol className="list-none mx-2 md:mx-0 p-0 inline-flex divide-x-[2px] divide-slate-300 ">
          <li className="flex items-center px-2">
            <a
              href="/"
              className={`text-gray-700 line-clamp-1 ${isRajasthan ? 'hover:text-rajasthanDark' : isMadhya ? 'hover:text-mpDark' : isHR ? 'hover:text-hrDark' : isBH ? 'hover:text-biharDark' : isUP ? 'hover:text-upDark' : isCGH ? 'hover:text-mpDark' : isUK ? "hover:text-ukDark" : isBiz ? "hover:text-bizDark" : isPB ? "hover:text-pbDark" : 'hover:text-primary'}`}
              style={{ display: "flex" }}
              onClick={() => {
                let currentPageVideoType =
                  window?.location?.href?.includes("/video/");
                let isStoryOrVideoDetail =
                  window?.location?.href?.includes("/video/") ||
                  window?.location?.href?.includes("/story/");
                if (isStoryOrVideoDetail) {
                  sendGAEvent({
                    eventName: currentPageVideoType
                      ? "VideoPage-BreadcrumbsClick"
                      : "ArticlePage-BreadcrumbsClick",
                    pageTitle: document?.title,
                    pageLocation: window?.location?.href,
                  });
                }
              }}
            >
              {/* <div className="min-w-[14px]" style={{ alignSelf: "center" }}>
                <SVG
                  className={`w-3 h-3 mx-1 ${isRajasthan ? 'hover:text-rajasthanDark' : isMadhya ? 'hover:text-mpDark' : isHR ? 'hover:text-hrDark' : isBH ? 'hover:text-biharDark' : isUP ? 'hover:text-upDark' : isCGH ? 'hover:text-mpDark' : isUK ? 'hover:text-ukDark' : 'hover:text-primary'}`}
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/menuHome.svg"
                />
              </div> */}
              होम
            </a>
          </li>
          {breadcrumbList?.map((item, index) => (
            <li key={index} className="flex items-center px-2">
              {item?.icon && (
                <div className="min-w-[14px]">
                  <SVG
                    className={`w-3 h-3 mx-1 ${isRajasthan ? 'hover:text-rajasthanDark' : isMadhya ? 'hover:text-mpDark' : isHR ? 'hover:text-hrDark' : isBH ? 'hover:text-biharDark' : isUP ? 'hover:text-upDark' : isCGH ? 'hover:text-mpDark' : isUK ? "hover:text-ukDark" : isBiz ? "hover:text-bizDark" : isPB ? "hover:text-pbDark" : 'hover:text-primary'}`}
                    src={item?.icon}
                  />
                </div>
              )}
              {index !== breadcrumbList.length - 1 ? <a
                href={item?.canonical_url}
                className={`text-gray-700 line-clamp-1 ${isRajasthan ? 'hover:text-rajasthanDark' : isMadhya ? 'hover:text-mpDark' : isHR ? 'hover:text-hrDark' : isBH ? 'hover:text-biharDark' : isUP ? 'hover:text-upDark' : isCGH ? 'hover:text-mpDark' : isUK ? "hover:text-ukDark" : isBiz ? "hover:text-bizDark" : isPB ? "hover:text-pbDark" : 'hover:text-primary'}`}
                aria-current="page"
                onClick={() => {
                  let currentPageVideoType =
                    window?.location?.href?.includes("/video/");

                  let isStoryOrVideoDetail =
                    window?.location?.href?.includes("/video/") ||
                    window?.location?.href?.includes("/story/");
                  if (isStoryOrVideoDetail) {
                    sendGAEvent({
                      eventName: currentPageVideoType
                        ? "VideoPage-BreadcrumbsClick"
                        : "ArticlePage-BreadcrumbsClick",
                      pageTitle: document?.title,
                      pageLocation: window?.location?.href,
                    });
                  }
                }}
              >
                {item?.title}
                {/* {index===breadcrumbList.length-1 &&  */}
                {/* <a
                //   href={titleUrl}
                //   className="text-gray-700 hover:text-primary"
                //   style={{ display: "flex" }}
                // >
                //   {title}
                // </a>
                // } */}
              </a> :
                <span className="text-gray-700 px-2   whitespace-nowrap line-clamp-1  ">
                  {item?.title}
                </span>
              }
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default index;
